import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"
dayjs.extend(utc)
import {
  IAvailableSlots,
  ITimeSlot,
  IImbpDay,
} from "./imbpAvailableSlots.types"
import { Status, StatusType } from "@/types/Status"

export class ImbpAvailableSlots implements IAvailableSlots {
  days: IImbpDay[]

  constructor(data: { days: IImbpDay[] }) {
    this.days = data.days.filter((day) => day.slots.length)
  }

  get hasAvailableSlots(): boolean {
    return !!this.days.length
  }

  get timeSlots(): ITimeSlot[] {
    const slotsArray = [] as ITimeSlot[]

    this.days.forEach((day) => {
      day.slots.forEach((slot) => {
        const startDate = dayjs(day.date + " " + slot.startTime).toDate()
        const endDate = dayjs(day.date + " " + slot.endTime).toDate()

        const timeRange = `${dayjs(startDate).format("ha")} - ${dayjs(
          endDate,
        ).format("ha")}`

        slotsArray.push({
          ...slot,
          timeSlot: slot["time-slot"],
          date: dayjs(startDate).format("YYYY-MM-DD"),
          dateTimeRange: [startDate, endDate],
          timeRange,
        })
      })
    })

    return slotsArray
  }

  get totalSlots(): number {
    return this.days.reduce((sum, cur) => sum + cur.slots.length, 0)
  }

  get slotsStatus() {
    const statusText = `${this.totalSlots.toString()} slots available`
    let statusType: StatusType

    if (this.totalSlots === 0) {
      statusType = "default"
    } else if (this.totalSlots >= 1 && this.totalSlots <= 5) {
      statusType = "critical"
    } else if (this.totalSlots >= 6 && this.totalSlots <= 10) {
      statusType = "caution"
    } else {
      statusType = "normal"
    }

    return new Status(statusType, statusText)
  }
}
